import appManager from '@app/appManager';
import AppModule from '@app/lib/AppModule';
import { AuthEvents, AuthUser } from '@modules/AuthModule/types';
import extractErrorMessage from '@lib/utils/extractErrorMessage';
import { AddressInput } from '@api/generated/graphql';
import updateUserE911Address from './updateUserE911Address';
import { ApolloError } from '@apollo/client';
import { convertAddressAndPopulateCountry } from './addressUtils';
import DiagnosticsModule from '@modules/DiagnosticsModule';
import { setUserE911AddressState } from '@modules/E911AddressModule/store';

export class E911AddressModule extends AppModule {
  override preload(): void {
    const updateE911Address = (user: AuthUser) => {
      if (user.e911Address) {
        setUserE911AddressState(
          convertAddressAndPopulateCountry(user.e911Address),
        );
      }
    };

    this.app.events.on(AuthEvents.SIGNIN, updateE911Address);
    this.app.events.on(AuthEvents.USER_UPDATED, updateE911Address);
  }

  public async setUserE911Address(userId: string, e911Address: AddressInput) {
    try {
      updateUserE911Address(userId, e911Address);
      setUserE911AddressState(e911Address);
    } catch (error) {
      if (error instanceof ApolloError) {
        DiagnosticsModule.reportUserError({
          message: error.message,
          priority: 'direct',
        });
        return;
      }
      throw new Error(extractErrorMessage(error));
    }
  }
}

export default new E911AddressModule(
  appManager.events,
  appManager.logger('E911Address'),
);
